import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ADPUsrService from "../../../../../services/admin/ADPUsrService";
import userService from "./user-service";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import BreadcrumbComponent from "../../../../../components/Breadcrumb";


interface DropdownItem {
  referenceName: string;
  referenceCode: string;
}
const currentDate = new Date();
const newDate = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000);

const Edit: React.FC = () => {
  const [user, setUser] = useState<any>({});
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const location = useLocation();
  const [clientState, setClientState] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const userId = location.state?.userId;
  const isEditMode = !!userId;

  const [departmentItems, setDepartmentItems] = useState<DropdownItem[]>([]);
  const [designationItems, setDesignationItems] = useState<DropdownItem[]>([]);
  const [userTypeItems, setUserTypeItems] = useState<DropdownItem[]>([]);
  const [systemActorItems, setSystemActorItems] = useState<DropdownItem[]>([]);
  const [acsItems, setAcsItems] = useState<DropdownItem[]>([]);
  const dropdownDepartmentItems = useMemo(() => departmentItems, [departmentItems]);
  const dropdownDesignationItems = useMemo(() => designationItems, [designationItems]);
  const dropdownUserTypeItems = useMemo(() => userTypeItems, [userTypeItems]);
  const dropdownSystemActorItems = useMemo(() => systemActorItems, [systemActorItems]);
  const dropdownAcsItems = useMemo(() => acsItems, [acsItems]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientStateItem = await userService.getClientState();
        setClientState(clientStateItem);

        const DeptData = await userService.getDeptDropdown();
        setDepartmentItems(DeptData);

        const DsgnData = await userService.getDsgnDropdown();
        setDesignationItems(DsgnData);

        const AcsData = await userService.getAcsDropdown(clientStateItem.facilityCode);
        setAcsItems(AcsData);

        const userTypeData = await userService.getUserTypeDropdown('USER_TYPE', 'ADP');
        setUserTypeItems(userTypeData);

        const systemActorData = await userService.getUserTypeDropdown('SYSTEM_ACTOR', 'ADP');
        setSystemActorItems(systemActorData);

        if (isEditMode) {
          userService.getUserById(userId).then((data) => {
           
            if (data?.ADPUsrtntHasOne?.programRoleId) {
              data.programRoleId = data.ADPUsrtntHasOne.programRoleId;
            }
            if (data?.ADPUsrtntHasOne?.authorizationLevel) {
              data.authorizationLevel = data.ADPUsrtntHasOne.authorizationLevel;
            }

            setUser(data);
          });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  function handleBack(): void {
    navigate(`/admin/user`);
  }

  const handleDropdownALChange = (e: { value: any; }) => {
    setUser({
      ...user,
      ADPUsrtntHasOne: {
        ...user.ADPUsrtntHasOne,
        authorizationLevel: e.value
      }
    });
  };

  const handleDropdownChange = (e: any) => {
    const { id, value } = e.target;
    setUser({
      ...user,
      [id]: value
    });
  };

  const handleSave = async () => {

    if (isEditMode) {
      user.modifiedBy = clientState.fullName;
      user.modifiedDate = newDate.toISOString();
    } else {
      user.insertBy = clientState.fullName;
      user.insertDate = newDate.toISOString();
      user.modifiedBy = clientState.fullName;
      user.modifiedDate = newDate.toISOString();
      user.facilityCode = clientState.facilityCode;
    }

    if (isEditMode) {
      try {

        const response = await userService.update(user.fullName, user);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        alert('Form submitted successfully!');
        navigate(`/admin/user`);
      } catch (error) {
        console.error("Error with Axios:", error);
        alert('Failed to submit the form.');
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await userService.create(user);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        alert('Form submitted successfully!');

        navigate(`/admin/user`);
      } catch (error) {
        console.error("Error with Axios:", error);
        alert('Failed to submit the form.');
      } finally {
        setLoading(false);
      }
    }
  }


  const toolbarTemplate = () => {
    return (
      <>
        <Toast ref={toast} />
        <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} onClick={() => handleSave()} />
        {/* <Button label="Delete" icon="pi pi-trash" style={{ marginRight: '.5em' }} /> */}
        <Button label="Back" icon="pi pi-times" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />

      </>
    );
  };


  return (
    <div className='grid'>
      <div className='col-12'>
        <div className='card-title'>
          <h5>User Form</h5>
          <BreadcrumbComponent />
        </div>

        <div className='form-title'>
          <Fieldset legend="User Information" >
            <div className="p-fluid form-grid grid">
              <div className="field col-12 md:col-6">
                <label htmlFor="fullName">Full Name</label>
                <InputText
                  id="fullName"
                  value={user.fullName || ""}
                  onChange={(e) => setUser({ ...user, fullName: e.target.value })} // Allow typing
                />
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="icNo">Id No</label>
                <InputText
                  id="icNo"
                  value={user.icNo || ""}
                  onChange={(e) => setUser({ ...user, icNo: e.target.value })}
                />
              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="email">Email</label>
                <InputText
                  id="email"
                  value={user.email || ""}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="departmentCode">Department</label>
                <Dropdown
                  id="departmentCode"
                  value={user.departmentCode}
                  onChange={handleDropdownChange}
                  options={dropdownDepartmentItems}
                  optionLabel="fullDesc"
                  placeholder="Select One"
                  optionValue="departmentCode"
                >
                </Dropdown>


              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="designationCode">Designation</label>
                <Dropdown
                  id="designationCode"
                  value={user.designationCode}
                  onChange={handleDropdownChange}
                  options={dropdownDesignationItems}
                  optionLabel="fullDesc"
                  placeholder="Select One"
                  optionValue="designationCode"
                  filter
                >
                </Dropdown>
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="designationGrade">Grade</label>
                <InputText
                  id="designationGrade"
                  value={user.designationGrade || ""}
                  onChange={(e) => setUser({ ...user, designationGrade: e.target.value })}
                />
              </div>
            </div>
          </Fieldset>


          <div>
            <br />
          </div>

          <div>
            <br />
          </div>
          <Fieldset legend="User Authentication & Authorization" toggleable>

            <div className="p-fluid form-grid grid">

              <div className="field col-12 md:col-6">
                <label htmlFor="username">Login Id</label>
                <InputText
                  id="username"
                  value={user.username || ""}
                  onChange={(e) => setUser({ ...user, designationGrade: e.target.value })}
                  disabled

                />
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="userType">User Type</label>
                <Dropdown
                  id="userType"
                  value={user.userType}
                  onChange={handleDropdownChange}
                  options={dropdownUserTypeItems}
                  optionLabel="fullDesc"
                  placeholder="Select One"
                  optionValue="referenceCode"
                >
                </Dropdown>

              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="programRoleId">Acces right</label>
                <Dropdown
                  id="programRoleId"
                  value={user.programRoleId}
                  onChange={handleDropdownChange}
                  options={dropdownAcsItems}
                  optionLabel="fullDesc"
                  placeholder="Select One"
                  optionValue="accessRoleId"
                >
                </Dropdown>
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="authorizationLevel">System Actor</label>
                <Dropdown
                  id="authorizationLevel"
                  value={
                    user?.ADPUsrtntHasOne?.authorizationLevel 
                      || user.authorizationLevel 
                      || ''
                  }
                  onChange={handleDropdownALChange}
                  options={dropdownSystemActorItems}
                  optionLabel="fullDesc"
                  placeholder="Select One"
                  optionValue="referenceCode"
                >
                </Dropdown>
              </div>
              <div className="field col-12 md:col-6">
                <h6>Status</h6>
                <InputSwitch
                  checked={(user.recordStatus ?? '1') === '1'}
                  onChange={(e) =>
                    setUser({ ...user, recordStatus: e.value ? "1" : "0" })
                  }
                />
              </div>
            </div>

          </Fieldset>
        </div>
        <br />
        <Toolbar end={toolbarTemplate}></Toolbar>
      </div>

    </div>

  );
};

export default Edit;
